import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchProjects(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/projects/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProject(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/projects/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editProject(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/projects", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProject(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/projects", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectDocument(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_documents", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectDocumentFile(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_documents/files", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },


    fetchInvoices(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/invoices", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    fetchProjectStage(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/project_stages`, { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
   editProjectStage(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`/project_stages/multi`, data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectStage(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_stages", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    editProjectStageInfo(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`/project_stages/info`, data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectStageInfo(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`/project_stages/info`, { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjecDrawing(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_drawings", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjecDrawingFile(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_drawings/files", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjecDrawingAllFiles(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_drawings/files/destroy-all", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },


    fetchProjectBookings(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/project_bookings`, { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
   editProjectBooking(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`/project_bookings`, data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectBooking(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_bookings", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    fetchProjectMessages(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/project_comments`, { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
   editProjectMessage(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`/project_comments`, data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectMessage(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_comments", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectMessageFile(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_comments/files", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    fetchReceipts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/receipts/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },


    fetchProjectActivitices(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/project_activities`, { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
   editProjectActivitice(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`/project_activities`, data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectActivitice(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_activities", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },


    deleteProjectDrawingApproveFile(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_drawings/approve_files", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteStageInfoFile(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_stages/info/files", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    }
  }
};
